import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  MyHrUserTwoFactorCardIsActive,
  MyHrUserTwoFactorCardIsLocked,
  MyHrUserTwoFactorCardNotActived,
} from "my-hr/components";
import { useOcTwoFactorEnabledState } from "oc/hooks/use-two-factor-enabled-state";

interface UserTwoFactorData {
  twoFactorType?: string;
  twoFactorEnabledAt?: string | Date;
  twoFactorEnabled?: boolean;
  twoFactorFailedCode?: number;
  // Add any other fields from userData as needed
}

interface MyHrUserTwoFactorCardTypesProps {
  userData: UserTwoFactorData;
}

export const MyHrUserTwoFactorCardTypes = ({
  userData,
}: MyHrUserTwoFactorCardTypesProps) => {
  const theme = useTheme();

  const { state: twoFactorEnabled } = useOcTwoFactorEnabledState();

  if (!twoFactorEnabled) {
    return null;
  }

  const twoFactorType = userData?.twoFactorType || "";
  const twoFactorEnabledAt = userData?.twoFactorEnabledAt
    ? new Date(userData.twoFactorEnabledAt).toLocaleDateString()
    : "";

  const isActive =
    userData?.twoFactorEnabled && (userData?.twoFactorFailedCode ?? 0) < 3;
  const isLocked =
    userData?.twoFactorEnabled && (userData?.twoFactorFailedCode ?? 0) >= 3;
  const notActived = !userData?.twoFactorEnabled;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.gray30.main,
        padding: "8px 16px",
        borderRadius: "4px",
      }}
    >
      {isActive && (
        <MyHrUserTwoFactorCardIsActive
          twoFactorType={twoFactorType}
          twoFactorEnabledAt={twoFactorEnabledAt}
          userData={{
            ...userData,
            twoFactorEnabledAt: userData?.twoFactorEnabledAt
              ? new Date(userData.twoFactorEnabledAt).toLocaleDateString()
              : undefined,
          }}
        />
      )}
      {isLocked && (
        <MyHrUserTwoFactorCardIsLocked
          userData={{
            ...userData,
            modifiedAt: (userData as any).modifiedAt ?? new Date(),
          }}
        />
      )}
      {notActived && <MyHrUserTwoFactorCardNotActived />}
    </Box>
  );
};

export default MyHrUserTwoFactorCardTypes;
